import _ from 'lodash';

import { loading, success, error } from 'State/actions';
import { RecipeCategoryEnum } from 'Common/Constants/Enumeration/RecipeCategoryEnum';
import { createMap } from 'Common/Helpers/format';
import { addRecipeToDays } from 'Pages/managemenu/state/editmenu/actions';
import * as EditMenusSelectors from 'Pages/managemenu/state/editmenu/selectors';

import * as types from './types';

export const getSearchFilters = () => async (dispatch, getState, MPWWebApi) => {
  try {
    dispatch(loading(types.GET_RECIPE_FILTER_OPTIONS, true));
    const response = await MPWWebApi.getGeneric(
      'Recipe/GetRecipeSearchFilters'
    );

    const data = response.data.Data;

    const normalizedRecipeCategories = createMap(data.RecipeCategories);
    // order recipe category array in same order as RecipeCategoryEnum
    const orderedRecipeCategories = Object.values(RecipeCategoryEnum).map(
      id => normalizedRecipeCategories[id]
    );

    dispatch(success(types.SET_RECIPE_CATEGORIES, orderedRecipeCategories));
    dispatch(success(types.SET_RECIPE_GROUPS, data.RecipeGroups));
    dispatch(success(types.SET_RECIPE_SOURCES, data.RecipeSources));
    dispatch(success(types.SET_RECIPE_HACCP, data.RecipeHACCP));
    dispatch(success(types.SET_RECIPE_SERVING_TEMP, data.RecipeServingTemp));
    dispatch(success(types.SET_HACCPS, data.HACCPs));
    dispatch(success(types.SET_HACCP_TYPES, data.HACCPTypes));
    dispatch(
      success(
        types.SET_RECIPE_INSTRUCTION_DESCRIPTIONS,
        data.InstructionDescriptions
      )
    );
    dispatch(success(types.SET_MEAL_TYPES, data.MealTypes));
  } catch (err) {
    const errorObj = _.get(err, 'response.data.Errors');

    if (errorObj) {
      dispatch(error(types.GET_RECIPE_FILTER_OPTIONS_ERROR, errorObj));
    } else {
      dispatch(
        error(types.GET_RECIPE_FILTER_OPTIONS_ERROR, [
          {
            Message: 'Could not load recipe filter options.',
          },
        ])
      );
    }
  } finally {
    dispatch(loading(types.GET_RECIPE_FILTER_OPTIONS, false));
  }
};

export const clearSelection = () => {
  return {
    type: types.CLEAR_SELECTION,
  };
};

export const unselectMenuItems = ids => ({
  type: types.UNSELECT_MENU_ITEMS,
  payload: ids,
});

export const unselectMenuItem = id => ({
  type: types.UNSELECT_MENU_ITEM,
  payload: id,
});

export const selectMenuItems = payload => ({
  type: types.SELECT_MENU_ITEMS,
  payload,
});

export const selectMenuItem = payload => ({
  type: types.SELECT_MENU_ITEM,
  payload,
});

export const copy = ({ days, recipes }) => ({
  type: types.EDIT_MENU_COPY,
  payload: {
    days,
    recipes,
  },
});

export const resetCopied = () => ({
  type: types.EDIT_MENU_RESET_COPIED,
});

/**
 *
 * @param {Object} param
 * @param {string} param.menuId
 * @param {number} param.servings
 * @param {string[]} param.copiedRecipes
 * @param {string[]} param.copiedDays
 * @param {string[]} param.selectedDays
 */
export const paste = ({
  menuId,
  servings,
  copiedRecipes,
  copiedDays,
  selectedDays,
}) => (dispatch, getState) => {
  const state = getState();
  const menuDaysMap = EditMenusSelectors.getMenuDaysMap(state);

  const errors = [];

  let numAdded = 0;

  selectedDays.forEach((selectedDay, index) => {
    // iterate through copied days, looping back
    const copiedDayIndex = index % copiedDays.length;
    const copiedDay = copiedDays[copiedDayIndex];
    const recipesForCopiedDay = menuDaysMap[copiedDay] || [];

    recipesForCopiedDay.forEach(recipeId => {
      const [added, error] = dispatch(
        addRecipeToDays({
          menuId,
          servings,
          recipeIndex: null,
          selectedDays: [selectedDay],
          showErrorToast: false,
          recipeId,
        })
      );

      if (error) {
        errors.push(error);
      }
      if (added) {
        numAdded += 1;
      }
    });
  });

  copiedRecipes.forEach(recipe => {
    const [added, error] = dispatch(
      addRecipeToDays({
        menuId,
        servings,
        recipeIndex: null,
        selectedDays,
        showErrorToast: false,
        recipeId: recipe,
      })
    );
    if (error) {
      errors.push(error);
    }
    if (added) {
      numAdded += 1;
    }
  });

  if (errors.length > 0) {
    const errorSet = new Set();
    errors.forEach(e => {
      errorSet.add(e.Message);
    });

    let errorMsg = '';
    [...errorSet].forEach(msg => (errorMsg += `${msg} `));
    dispatch(error(types.SET_ERROR, { Title: 'Error', Message: errorMsg }));
  }

  return numAdded > 0;
};



// WEBPACK FOOTER //
// ./src/pages/managemenu/state/common/actions.js